










import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import {publishSheetOrders} from '@/services/SheetOrderService';
import {LayoutModule, NotificationType} from '@/store/modules/LayoutModule';
import {ModuleShop} from '@/store/modules/ShopModule';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';

@Component({})
export default class PublishFulfillmentBtn extends Vue {
  @Prop({required: true, type: Number}) sheetOrderId: number;
  @Prop({default: false, type: Boolean}) disabled: number;
  loading: boolean = false;

  get shopId() {
    return ModuleShop.shopId;
  }

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  @Emit('success')
  async submit() {
    try {
      this.loading = true;
      const result = await publishSheetOrders(this.organizationId, this.shopId, this.sheetOrderId);
      if (result) {
        LayoutModule.showNotification({text: 'Publish success'});
        return true;
      } else {
        LayoutModule.showNotification({text: 'Error!', type: NotificationType.ERROR});
      }
    } finally {
      this.loading = false;
    }

    return false;
  }
}
